// Короткий тег устройства для суффикса FIFO-номера этикетки.
//
// Зачем. Номер FIFO присваивает клиент из своего ЛОКАЛЬНОГО кэша, а суффикс — это
// инициалы человека (решение Д2). Пока на кухне одно устройство на человека, номер
// уникален. Но D6 — один принтер, устройств несколько, и «Су-шеф Петров» может
// печатать с общего планшета И с общего телефона под одной учёткой. Одно офлайн —
// и оба вычисляют один номер из своих кэшей: на полке две «№8/СП», не различить
// (проверено на живом железе 2026-09-07). Сервер номер не перенумеровывает.
//
// Тег устройства разводит их: `№8/СП·A3F1` против `№8/СП·B2C2` — разные этикетки.
// Первоначальный дизайн ровно это и предполагал (`PrintJob.fifo_number`, коммент
// «Скоупится устройством `№3/К2`»); Д2 сменил суффикс на человека и гарантию потерял.
//
// Тег принадлежит УСТРОЙСТВУ, не человеку: выход повара его не трогает, следующий
// печатает с тем же тегом. Живёт до переустановки приложения — этого достаточно,
// потому что переустановка и так обнуляет локальный кэш и последовательность номеров.

import { Preferences } from '@capacitor/preferences';

import { uuid } from '@/shared/lib';

import { PREFERENCE_KEYS } from './preferenceKeys';

// Копия в памяти: `PrintPage` строит суффикс СИНХРОННО в момент печати, а чтение
// из Preferences асинхронно. `restoreDeviceTag()` наполняет её на старте, как токен.
let cached: string | null = null;

/** Четыре HEX-символа в верхнем регистре: 65 536 вариантов — с запасом на сеть. */
function generate(): string {
  return uuid().replace(/-/g, '').slice(0, 4).toUpperCase();
}

/**
 * Тег этого устройства. Пустая строка ТОЛЬКО до `restoreDeviceTag()` — то есть
 * не в реальном потоке печати, где рестор уже прошёл на бутстрапе.
 */
export function deviceTag(): string {
  return cached ?? '';
}

/**
 * Прочитать тег из хранилища; при первом запуске — сгенерировать и сохранить.
 * Вызывается на бутстрапе (`main.tsx`) до первого рендера.
 */
export async function restoreDeviceTag(): Promise<string> {
  const { value } = await Preferences.get({ key: PREFERENCE_KEYS.deviceTag });
  if (value) {
    cached = value;
    return value;
  }
  const next = generate();
  cached = next;
  await Preferences.set({ key: PREFERENCE_KEYS.deviceTag, value: next });
  return next;
}
